import React, { useRef, useState, useEffect } from 'react'
import './editMenu.css'
import goBackPic from './../../assets/back.png'
import NewProduct from './menuOptions/newProduct'
import NewCategory from './menuOptions/newCategory'
import Menu from './../../menu/menu'
import EditProduct from './menuOptions/editProduct'
import RemoveEditCategory from './menuOptions/removeEditCategory'
import firebase from './../../../config/fbConfig'
import RemoveProduct from './menuOptions/removeProduct'
import HideOrderCategory from './menuOptions/hideOrderCategory'

const db = firebase.firestore();

function EditMenu() {
    // Rendering the page according to the user's pick action
    const [chosenAction, setChosenAction] = useState({ optionNum: 0, name: "" })
    const chosenLang = useRef((window.location.href.includes('/en')) ? "EN" : "HE") // Default english, used to know which category to update 
    const allMenus = useRef(null) // storing all the languages available
    const menu = useRef(null) // Storing the specific menu of the chosen langauges
    const [menuExist, setMenuExist] = useState(false)

    useEffect(() => {
        db.collection("menu").doc('categories').get().then(function (querySnapshot) {
            if (window.location.href.includes('/en')) {
                allMenus.current = [querySnapshot.data().categoriesEN, querySnapshot.data().categoriesHE];
            } else {
                allMenus.current = [querySnapshot.data().categoriesHE, querySnapshot.data().categoriesEN];
            }
            menu.current = allMenus.current[0];
            setMenuExist(true);
        })
    }, [])
    let enterFilteredOption = (chosenAction, titleChosen) => {
        setChosenAction({ optionNum: chosenAction, name: titleChosen });
        document.getElementById('selectLang').disabled = true;
        if (document.getElementById('selectLang').value === "HE") {
            document.getElementById('editMenu').classList.add('hebrewInputs');
        } else {
            document.getElementById('editMenu').classList.remove('hebrewInputs');
        }
    }
    if (!menuExist) return <img id="loadingGif" src="/assets/loadingGif.gif" />;


    if (window.location.href.includes('/en')) {
        return (
            <div id="editMenu">
                <select id="selectLang" defaultValue="English" onChange={(e) => { menu.current = allMenus.current[e.target.selectedIndex]; chosenLang.current = e.target.value }}>
                    <option value="EN">English</option>
                    <option value="HE">עברית</option>
                </select>

                {chosenAction.optionNum == 0 ? <div className="titleComponent">Edit Menu</div> : <div className="titleComponent">{chosenAction.name}</div>}
                {chosenAction.optionNum == 0 &&
                    <div id="editOptions">
                        <button data-chosen="2" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>Add a new item</button>
                        <button data-chosen="1" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>Add a new category</button>
                        <button data-chosen="3" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>Remove/Edit an existing category</button>
                        <button data-chosen="4" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>Edit an existing item</button>
                        <button data-chosen="5" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>Un/Hide and order categories</button>
                        <button data-chosen="6" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>Remove an existing item</button>
                        <button id="ViewMenu" data-chosen="7" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>View Menu As Admin</button>
                    </div>
                }
                {chosenAction.optionNum != 0 &&
                    <div id="filteredOption">
                        <img src={goBackPic} id="goBackPic" onClick={() => { setChosenAction({ optionNum: 0 }); document.getElementById('selectLang').disabled = false; }} />
                        {chosenAction.optionNum == 1 && <NewCategory menu={menu.current} chosenLang={chosenLang.current} />}
                        {chosenAction.optionNum == 2 && <NewProduct menu={menu.current} chosenLang={chosenLang.current} />}
                        {chosenAction.optionNum == 3 && <RemoveEditCategory menu={menu.current} chosenLang={chosenLang.current} />}
                        {chosenAction.optionNum == 4 && <EditProduct menu={menu.current} chosenLang={chosenLang.current} />}
                        {chosenAction.optionNum == 5 && <HideOrderCategory menu={menu.current} chosenLang={chosenLang.current} />}
                        {chosenAction.optionNum == 6 && <RemoveProduct menu={menu.current} chosenLang={chosenLang.current} />}
                        {chosenAction.optionNum == 7 && <Menu isAdmin={true} menu={menu.current} chosenLang={chosenLang.current} />}
                    </div>
                }
            </div>
        )
    }

    return (
        <div id="editMenu">
            <select id="selectLang" defaultValue="English" onChange={(e) => { menu.current = allMenus.current[e.target.selectedIndex]; chosenLang.current = e.target.value }}>
                <option value="HE">עברית</option>
                <option value="EN">English</option>
            </select>

            {chosenAction.optionNum == 0 ? <div className="titleComponent">עריכת תפריט</div> : <div className="titleComponent">{chosenAction.name}</div>}
            {chosenAction.optionNum == 0 &&
                <div id="editOptions">
                    <button data-chosen="2" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>צור מוצר חדש</button>
                    <button data-chosen="1" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>הוסף קטגוריה חדשה</button>
                    <button data-chosen="3" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>ערוך/מחק קטגוריה קיימת</button>
                    <button data-chosen="4" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>ערוך מוצר קיים</button>
                    <button data-chosen="5" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>הסתרה/חשיפה וסידור קטגוריות</button>
                    <button data-chosen="6" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>מחיקת מוצר קיים</button>
                    <button id="ViewMenu" data-chosen="7" onClick={(e) => enterFilteredOption(e.target.dataset.chosen, e.target.innerHTML)}>צפייה בתפריט כמנהל</button>
                </div>
            }
            {chosenAction.optionNum != 0 &&
                <div id="filteredOption">
                    <img src={goBackPic} id="goBackPic" onClick={() => { setChosenAction({ optionNum: 0 }); document.getElementById('selectLang').disabled = false; }} />
                    {chosenAction.optionNum == 1 && <NewCategory menu={menu.current} chosenLang={chosenLang.current} />}
                    {chosenAction.optionNum == 2 && <NewProduct menu={menu.current} chosenLang={chosenLang.current} />}
                    {chosenAction.optionNum == 3 && <RemoveEditCategory menu={menu.current} chosenLang={chosenLang.current} />}
                    {chosenAction.optionNum == 4 && <EditProduct menu={menu.current} chosenLang={chosenLang.current} />}
                    {chosenAction.optionNum == 5 && <HideOrderCategory menu={menu.current} chosenLang={chosenLang.current} />}
                    {chosenAction.optionNum == 6 && <RemoveProduct menu={menu.current} chosenLang={chosenLang.current} />}
                    {chosenAction.optionNum == 7 && <Menu isAdmin={true} menu={menu.current} chosenLang={chosenLang.current} />}
                </div>
            }
        </div>
    )
}

export default EditMenu
